import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app";
import { session } from "./lib/api";
import "./index.css";

// Silent sign-in: Identity's refresh cookie is shared by every CortexGrip app. Telling the other tabs
// matters after a provider (Google/GitHub) sign-in in a new tab: a page waiting under the session-expired
// prompt carries on by itself. Tabs that are already signed in ignore it.
void session.refresh().then((signedIn) => {
  if (signedIn) session.announceSignIn();
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
